import {
  createEntityAdapter,
  createSlice,
  PayloadAction,
} from '@reduxjs/toolkit';

export interface ElearningCommentsStateType {
  reviewerId: string;
  isOpen: boolean;
}

const elearningCommentsAdapter = createEntityAdapter();

const initialState: ElearningCommentsStateType =
  elearningCommentsAdapter.getInitialState({
    isOpen: false,
    reviewerId: '',
  });

interface ReviewerIdType {
  reviewerId: string;
}

const elearningCommentsSlice = createSlice({
  name: 'elearningComments',
  initialState,
  reducers: {
    openCommentsModal: (state, action: PayloadAction<ReviewerIdType>) => {
      state.reviewerId = action.payload.reviewerId;
      state.isOpen = true;
    },
    closeCommentsModal: (state) => {
      state.reviewerId = '';
      state.isOpen = false;
    },
  },
});

export const { name, actions, reducer } = elearningCommentsSlice;
